import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import VerifiedIcon from '@mui/icons-material/Verified';
import NewOpenLeadList from "./NewOpenLeadList";
import NewClosedLeadList from "./NewClosedLeadList";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
};

function NewLeadTabComponent() {
    const [value, setValue] = useState(0);
      const handleChange = (event, newValue) => {
        setValue(newValue);
      };

      const [openCount, setOpenCount] = useState(0);
      const [closedCount, setClosedCount] = useState(0);

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab
          label={`Open (${openCount || 0})`}
          id="tab-0"
          icon={<NewReleasesIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
        <Tab
          label={`Closed (${closedCount || 0})`}
          id="tab-1"
          icon={<VerifiedIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
      </Tabs>

      <TabPanel value={value} index={0}>
        <NewOpenLeadList setOpenCount={setOpenCount} setClosedCount={setClosedCount}></NewOpenLeadList>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <NewClosedLeadList setOpenCount={setOpenCount} setClosedCount={setClosedCount}></NewClosedLeadList>
      </TabPanel>
    </>
  );
}

export default NewLeadTabComponent;
